import React, { useState } from "react";
import FormUser from "./FormUser";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import {
  useGetGuestUserQuery,
  useGetProfileUserQuery,
} from "../../api/user/modificaProfiloApi";
import { t } from "i18next";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import EditMail from "../../common/EditMail/EditMail";
import ModificaPasswordPage from "../../common/EditPassword/ModificaPasswordPage";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import UserFamilyComponent from "./UserFamilyComponent";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";

const ModificaProfiloPage = () => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const family = appConfig?.modules?.family;
  const [selectedTab, setSelectedTab] = useState(1);

  const navigate = useNavigate();

  const { data: dataProfile, isLoading: loadingProfile } =
    useGetProfileUserQuery();
  const { data: dataGuest, isLoading: loadingGuest } = useGetGuestUserQuery();

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  if (loadingProfile && loadingGuest) {
    return <CoreSpinner />;
  }

  const formCmpany = {
    [t("Name")]: dataProfile?.Data?.userCompany?.name,
    [t("Address")]: dataProfile?.Data?.userCompany?.address,
    [t("VAT")]: dataProfile?.Data?.userCompany?.vat,
  };

  return (
    <div className="flex flex-col items-center">
      <h2 className="text-center py-4 mb-8">{t("EditProfile")}</h2>
      {/* Form */}
      <div className="flex w-11/12 justify-center gap-14 h-full">
        <div className="w-6/12 h-full flex flex-col gap-4">
          <Card className="w-full">
            <CardHeader
              avatar={
                <Avatar>
                  {dataProfile
                    ? (
                        dataProfile?.Data?.name[0] +
                        dataProfile?.Data?.surname[0]
                      ).toUpperCase()
                    : ""}
                </Avatar>
              }
              title={
                <Typography variant="h6" fontWeight={700}>
                  {t("Data")} {dataProfile?.Data?.isCompany && t("Company")}
                </Typography>
              }
            />
            <CardContent className="flex flex-col gap-7">
              {dataProfile?.Data?.isCompany ? (
                <>
                  {Object.entries(formCmpany).map(([key, value]) => (
                    <>
                      <div className="w-11/12 flex justify-between">
                        <Typography>{key}</Typography>
                        <Typography fontWeight={700}>{value}</Typography>
                      </div>
                      <Divider />
                    </>
                  ))}
                  <div className="w-full flex justify-center">
                    <CoreButton
                      sx={{ width: "150px", textAlign: "center" }}
                      className={"btn-round"}
                      variant="contained"
                      testo={t("Edit")}
                      onClick={() =>
                        navigate(`/auth/user/${t("edit-company")}`, {
                          state: {
                            companyToEdit: dataProfile?.Data?.userCompany,
                          },
                        })
                      }
                    />
                  </div>
                </>
              ) : (
                <FormUser
                  user={dataProfile?.Data}
                  employment={dataGuest?.Data?.employmentStatusTypes || []}
                />
              )}
            </CardContent>
          </Card>
        </div>

        <div className="flex flex-col w-6/12 gap-4">
          {family && !dataProfile?.Data?.isCompany && (
            <Tabs
              value={selectedTab}
              onChange={handleChange}
              aria-label="Altri Servizi Tabs"
            >
              <Tab label={t("Impostazioni")} value={1} />
              <Tab label={t("Nucleo Familiare")} value={2} />
            </Tabs>
          )}
          {selectedTab === 2 && (
            <Card className="w-full justify-center mt-8">
              <CardHeader
                avatar={
                  <Avatar>
                    <GroupsRoundedIcon />
                  </Avatar>
                }
                title={
                  <Typography variant="h6" fontWeight={700}>
                    {t("Nucleo Familiare")}
                  </Typography>
                }
              />
              <CardContent>
                <UserFamilyComponent hideTitle={true} />
              </CardContent>
            </Card>
          )}
          {selectedTab === 1 && (
            <div className="w-full flex flex-col justify-between h-full">
              <Card className="w-full">
                <CardHeader
                  avatar={
                    <Avatar>
                      <MailOutlineRoundedIcon />
                    </Avatar>
                  }
                  title={
                    <Typography variant="h6" fontWeight={700}>
                      {t("EditMail")}
                    </Typography>
                  }
                />
                <CardContent>
                  <EditMail cardElement={true} />
                </CardContent>
              </Card>
              <Card className="w-full justify-center mt-8">
                <CardHeader
                  avatar={
                    <Avatar>
                      <LockRoundedIcon />
                    </Avatar>
                  }
                  title={
                    <Typography variant="h6" fontWeight={700}>
                      {t("EditPassword")}
                    </Typography>
                  }
                />
                <CardContent>
                  <ModificaPasswordPage cardElement={true} />
                </CardContent>
              </Card>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModificaProfiloPage;
